import { Swiper, Navigation, Pagination, Autoplay } from "swiper/bundle";
export default class SwipeQuote2 {
    constructor() {
        console.log('%c👍🏼 Swiper Quote 2', 'color: yellow');
        
        this.swiperQuote = document.querySelectorAll(
            '.swiper--quote-2'
        )
    }
    init() {
        this.swiperQuote.forEach((elem, i) => {
            
            new Swiper(elem, {
                slidesPerView: 1.3,
               
                loop: true,
                spaceBetween: 20,
                speed: 1001,
                // direction: 'vertical',
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    568: {
                        slidesPerView: 2.3
                    },
                    992: {
                        slidesPerView: 3
                    }
                }

            });                   
        })
    }
}

